import { render, staticRenderFns } from "./FullScreenForm.vue?vue&type=template&id=bbc08ece&"
import script from "./FullScreenForm.vue?vue&type=script&lang=js&"
export * from "./FullScreenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/tablefever-websites/src/vue-apps/manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc08ece')) {
      api.createRecord('bbc08ece', component.options)
    } else {
      api.reload('bbc08ece', component.options)
    }
    module.hot.accept("./FullScreenForm.vue?vue&type=template&id=bbc08ece&", function () {
      api.rerender('bbc08ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/FullScreenForm.vue"
export default component.exports